import * as R from 'ramda'
// used to pause on a tick, cleaner then timeouts.
// const dude = async () => {
// await pause(200)
// doSomething()
// }
export const pause = async (ms) => {
  return new Promise((resolve) => window.setTimeout(resolve, ms))
}

export const delay = async (fn, ms) => {
  await pause(ms)
  await fn()
}

export const isNumeric = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value)
}

export const uniqueID = () => `_${Math.random().toString(36).substr(2, 9)}`

// this is better debounce.
// This is basically lodash debounce with one core difference
// the initial invocation passed through debounce will execute immeadately
export const debounce = (func, wait: any, immediate = false) => {
  let timeout = -1
  const minWait = 10 // minimum amount of time it takes for any given user interaction (mouse click, key stroke)

  return (...args) => {
    const callNow = immediate && !timeout

    const later = function () {
      timeout = -1
      if (!immediate) {
        func.apply(this, args)
      }
    }

    if (timeout < 0) {
      func.apply(this, args)
      timeout = window.setTimeout(later, minWait)
    } else {
      clearTimeout(timeout)
      timeout = window.setTimeout(later, wait)
    }

    if (callNow) {
      func.apply(this, args)
    }
  }
}

export const isAllZeros = (currentVal?: number, prevVal?: number) => {
  return R.isNil(prevVal) || (currentVal === 0 && prevVal === 0)
}

/**
 * Divides two numbers, equivalent to a/b.
 *
 * Returns 0 instead of NaN or Infinity if divisor is 0.
 */
export const safeDivide: typeof R.divide = R.curry(
  R.compose(R.ifElse(Number.isFinite, R.identity, R.always(0)), R.divide)
)

export const isBetween = (
  min: number,
  max: number,
  val: number,
  inclusive = false
) => {
  const predicate = inclusive
    ? R.both(R.lte(min), R.gte(max))
    : R.both(R.lt(min), R.gt(max))
  return predicate(val)
}
